interface FusionChartsEvent{
  eventObj: Object;
  dataObj: Object;
}
export default FusionChartsEvent;